
// ux_04_032
import '@/assets/scss/index.scss'
import { pdMixin } from '@/mixin/pd/pdMixin'

export default {
  components: {
  },
  mixins: [pdMixin],
  data () {
    return {
      visible: false,
      data: {}, // 레이어 부모창에서 가져온 값
      stmtList: [], // 신고 항목 리스트
      form: {
        stmtRsnCd: '01',
        etcCn: ''
      },
      rules: {
        stmtRsnCd: [
          { required: true, message: '신고 사유를 선택해주세요.', trigger: 'change' }
        ],
        etcCn: [
          { required: true, message: '신고 사유는 10자 이상 입력해야 합니다.', trigger: 'blur' },
          { min: 10, message: '신고 사유는 10자 이상 입력해야 합니다.', trigger: 'blur' },
          { max: 500, message: '신고 사유는 500자 이하로 입력해야 합니다.', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    async visible (flag) {
      if (flag) {
        if (!this.isLogin) {
          // 로그인 체크
          this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
          return
        }
        this.form.revwMngNo = this.data.revwMngNo // 부모창에서 받아온 정보(클릭한 리뷰 관리번호)
        await this.selRevwStmtList()
      } else {
        // 팝업 닫을 때 초기화
        this.$refs.form.resetFields() // validate 초기화
        this.form.stmtRsnCd = '01' // 신고항목 첫번째항목으로 기본값 셋팅
      }
    }

  },
  mounted () {
  },
  methods: {
    close () {
      // 작성한 내용이 사라집니다. 레이어를 닫으시겠습니까?
      this.confirm(this.$t('CM.CLOSE_LAYER_NO_SAVE_CONFIRM'), {
        okCallback: () => {
          this.visible = false
        },
      })
    },

    // 리뷰 신고항목 조회
    async selRevwStmtList () {
      await this.$AxiosBuilder
        .data({ revwMngNo: this.data.revwMngNo })
        .build()
        .post('/pd/pds/revw/selRevwStmtWrt')
        .then((res) => {
          const result = res.data.data
          if (res.data.success) {
            this.stmtList = result
          } else {
            this.alert(res.data.message, {
              okCallback: () => {
                this.visible = false
              }
            })
          }
        }).catch((e) => {
          console.log('LayerRevwStmt selRevwStmtList error : ', e)
        })
    },

    // form validation focus
    checkValidate () {
      this.$refs.form.validate((valid, obj) => {
        if (!valid) {
          // validate check object 첫번째 필드 포커스
          const field = Object.keys(obj)[0]
          this.$refs[field].focus()
        } else {
          this.saveRevwStmt()
        }
      })
    },

    // 리뷰 신고내용 저장
    saveRevwStmt () {
      this.$AxiosBuilder
        .data({ revwMngNo: this.data.revwMngNo, ...this.form })
        .build()
        .post('/pd/pds/revw/saveRevwStmt')
        .then((res) => {
          if (res.data.success) {
            // 신고가 접수되었습니다.
            this.openToast(this.$t('CM.STMT_ACCEPTED'))
            this.visible = false
          } else {
            // 저장에 실패했습니다.
            this.alert(this.$t('CM.SAVE_FAIL'))
          }
        }).catch((e) => {
          console.log('LayerRevwStmt saveRevwStmt error : ', e)
        })
    },

    // input maxlength 이상 입력 안되게
    checkLength (obj) {
      const el = this.$refs[obj].$el.querySelector('textarea')
      this.form[obj] = el.value.slice(0, el.maxLength)
    }
  }
}
